import { george, helpers, pr, theme } from "aaa";
import { ActionButton } from "components/common/georgeComponents";
import { InfoBox } from "components/common/InfoBox";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { replaceRoute } from "stores/RouterFunctions";
import toastSore from "stores/ToastStore";
import { formatIban } from "util/helpers";
import { ShowCardDataRoutes } from "./ShowCardDataRoutes";
import ShowCardDataStore from "./ShowCardDataStore";

type IProps = {
    store: ShowCardDataStore
};

const DetailSection = observer(({ label, value, action }: { label: string, value: string, action: React.ReactNode }) => (
    <div style={{ display: "flex", justifyContent: "space-between", padding: theme.MARGIN, flexDirection: ui.isMobile ? "column" : "row" }}>
        <div style={{ flexBasis: 0, flexGrow: 1 }}>
            <pr.P_14_TITLE style={{ fontWeight: 600 }}>{label}</pr.P_14_TITLE>
            <pr.P_28_TITLE style={{ fontWeight: "bold" }}>{value}</pr.P_28_TITLE>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: ui.isMobile ? theme.MARGIN_SMALL : undefined }}>
            {action}
        </div>
    </div>
));

const CopyButton = observer(({ onClick }: { onClick: () => void }) => (
    <div
        role="button"
        onClick={onClick}
        tabIndex={0}
        className="theme-secondary-action-label-color"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            padding: "0 20px",
            width: ui.isMobile ? "100%" : undefined,
            height: 40,
            cursor: "pointer",
            border: `2px solid ${theme.customColors.georgeInputFrame}`,
            borderRadius: theme.BORDER_RADIUS
        }}
    >
        <pr.IconCopy />
        <span style={{ marginLeft: 5 }}>{ui.__("common.copy")}</span>
    </div>
));

export const ShowCardDataDetails = observer(({ store }: IProps) => {
    const [count, setCount] = React.useState(60);
    const id = React.useRef<number | null>(null);

    const clear = () => {
        if (id.current) {
            window.clearInterval(id.current);
        }
    };

    React.useEffect(() => {
        id.current = window.setInterval(() => {
            setCount(time => time - 1);
        }, 1000);

        return () => {
            clear();
        };
    }, []);

    React.useEffect(() => {
        if (count === 0) {
            clear();
            handleClickHide();
        }
    }, [count]);

    const handleCopy = (text: string) => () => {
        helpers.copyTextToClipboard(text);
        toastSore.addMessage(ui.__("showCardData.details.copy.toast"));
    };

    const handleClickHide = () => {
        store.cardPAN = ""; // reset for security reasons
        replaceRoute(ShowCardDataRoutes.SUCCESS);
    };

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;
    const cardPAN = formatIban(store.cardPAN || store.cardStore.card?.number);

    return (
        <george.Background>
            <PageComponent>
                <george.Card>
                    <DetailSection label={ui.__("showCardData.details.fullCardNumber.label")} value={cardPAN} action={<CopyButton onClick={handleCopy(cardPAN)} />} />
                    <div style={{ padding: theme.MARGIN }}>
                        <InfoBox
                            style={{ margin: 0, width: "100%" }}
                            content={(
                                <pr.P_16_CONTENT>
                                    <FormattedHTMLMessage id={store.displayChannel === "SMS" ? "showCardData.details.info.sms" : "showCardData.details.info.oob"} />
                                </pr.P_16_CONTENT>
                            )}
                        />
                    </div>
                    <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    <div style={{ textAlign: "center", padding: theme.MARGIN, paddingBottom: externalInterfaceStore.isGeorgeApp ? theme.MARGIN_LARGE : 0 }}>
                        <pr.P_16_CONTENT>{ui.__("showCardData.details.hideInfo", { count })}</pr.P_16_CONTENT>
                    </div>
                    <ActionButton
                        primary
                        messageId="showCardData.details.button.text"
                        onClick={handleClickHide}
                        {...george.getActionButtonWebVersionProps()}
                    />
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/showCardData/ShowCardDataDetails.tsx